<template>
    <!--頁首類別選單-->
    <div class="menuall">
        <nav class="menucon">
            <ul>
                <!--TODO class 後續新增各類別英文名稱作為代號-->
                <!--TODO 動態設定下拉選單功能-->
                <!--mn0x=為開啟指定類別詳細選單 mnaw=標示還有可以下拉內容-->
                <li class="mnu mn01 mnaw">
                    <!--TODO 動態抓取類別資訊-->
                    <!--主類別標題文字-->
                    <a href="/News" :class="(place=='News')?'mnusel':''">最新消息</a>
                    <div class="sum01 submenu">
                        <div class="submncon" >
                            <!--主類別標題文字-->
                            <div class="subtit">
                                <!--TODO 動態抓取文字-->
                                最新消息
                            </div>
                            <!--次類別-->
                            <div class="subselcon">
                                <div class="subselbox"v-for="(item,index) in GetSublist('PJ202503')">
                                    <a :href="'/News?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                        {{ item.PJ_NAME }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="mnu mn02 mnaw">
                    <!--TODO 動態抓取類別資訊-->
                    <!--主類別標題文字-->
                    <a href="/About" :class="(place=='About')?'mnusel':''">關於生傳</a>
                    <div class="sum02 submenu">
                        <div class="submncon">
                            <!--主類別標題文字-->
                            <div class="subtit">
                                <!--TODO 動態抓取文字-->
                                關於生傳
                            </div>
                            <!--次類別-->
                            <div class="subselcon">
                                <div class="subselbox"v-for="(item,index) in GetSublist('PJ202504')">
                                    <a :href="'/About?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                        {{ item.PJ_NAME }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="mnu mn03 mnaw">
                    <!--TODO 動態抓取類別資訊-->
                    <!--主類別標題文字-->
                    <a href="/Member" :class="(place=='Member')?'mnusel':''">系所成員</a>
                    <div class="sum03 submenu">
                        <div class="submncon">
                            <!--主類別標題文字-->
                            <div class="subtit">
                                <!--TODO 動態抓取文字-->
                                系所成員
                            </div>
                            <!--次類別-->
                            <div class="subselcon">
                                <div class="subselbox"v-for="(item,index) in GetSublist('PJ202505')">
                                    <a :href="'/Member?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                        {{ item.PJ_NAME }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="mnu mn04 mnaw">
                    <!--TODO 動態抓取類別資訊-->
                    <!--主類別標題文字-->
                    <a href="/Admissions" :class="(place=='Admissions')?'mnusel':''">招生訊息</a>
                    <div class="sum04 submenu">
                        <div class="submncon">
                            <!--主類別標題文字-->
                            <div class="subtit">
                                <!--TODO 動態抓取文字-->
                                招生訊息
                            </div>
                            <!--次類別-->
                            <div class="subselcon">
                                <div class="subselbox"v-for="(item,index) in GetSublist('PJ202506')">
                                    <a :href="'/Admissions?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                        {{ item.PJ_NAME }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="mnu mn05 mnaw">
                    <!--TODO 動態抓取類別資訊-->
                    <!--主類別標題文字-->
                    <a href="/Curriculum" :class="(place=='Curriculum')?'mnusel':''">課程資訊</a>
                    <div class="sum05 submenu">
                        <div class="submncon">
                            <!--主類別標題文字-->
                            <div class="subtit">
                                <!--TODO 動態抓取文字-->
                                課程資訊
                            </div>
                            <!--次類別-->
                            <div class="subselcon">
                                <div class="subselbox"v-for="(item,index) in GetSublist('PJ202507')">
                                    <a :href="'/Curriculum?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                        {{ item.PJ_NAME }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="mnu mn07 mnaw">
                    <!--TODO 動態抓取類別資訊-->
                    <!--主類別標題文字-->
                    <a href="/InServiceMaster" :class="(place=='InServiceMaster')?'mnusel':''">碩士在職專班</a>
                    <div class="sum07 submenu">
                        <div class="submncon">
                            <!--主類別標題文字-->
                            <div class="subtit">
                                <!--TODO 動態抓取文字-->
                                碩士在職專班
                            </div>
                            <!--次類別-->
                            <div class="subselcon">
                                <div class="subselbox" v-for="(item,index) in GetSublist('PJ202511')">
                                    <a :href="'/InServiceMaster?PJ_ID=' +item.PJ_ID+ '&modal='+item.modal">
                                        {{ item.PJ_NAME }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </li>
                <li class="mnu mn06 mnaw" >
                    <!--TODO 切版目前位置為此，後續確認是否調整-->
                    <!--TODO 動態抓取類別資訊-->
                    <!--主類別標題文字-->
                    <a href="/Research" :class="(place=='Research')?'mnusel':''">學術研究</a>
                    <div class="sum06 submenu">
                        <div class="submncon">
                            <!--主類別標題文字-->
                            <div class="subtit">
                                <!--TODO 動態抓取文字-->
                                學術研究
                            </div>
                            <!--次類別-->
                            <div class="subselcon">
                                <div class="subselbox"v-for="(item,index) in GetSublist('PJ202508')">
                                    <a :href="'/Research?PJ_ID='+item.PJ_ID+ '&modal='+item.modal">
                                        {{ item.PJ_NAME }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="mnu mn07 " v-if="headerData.filter(x => x.PJ_ID == 'PJ202509').length > 0">
                    <!--TODO 動態抓取類別資訊-->
                    <!--主類別標題文字-->
                    <a href="/Forms" :class="(place=='Forms')?'mnusel':''">常用表單</a>
                </li>
                <li class="mnu mn08 mnaw">
                    <!--TODO 動態抓取類別資訊-->
                    <!--主類別標題文字-->
                    <a href="#" :class="(place=='Links')?'mnusel':''">友站連結</a>
                    <div class="sum08 submenu">
                        <div class="submncon">
                            <!--主類別標題文字-->
                            <div class="subtit">
                                <!--TODO 動態抓取文字-->
                                友站連結
                            </div>
                            <!--次類別-->
                            <div class="subselcon">
                                <div class="subselbox" v-for="(item,index) in GetSublist('PJ202510').filter(x => { return x.modal==langurage })">
                                    <a :href="item.PJ_ENAME" target="_blank">
                                        {{ item.PJ_NAME }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </li>
            </ul>
        </nav>
    </div>
</template> 
<script>

export default{
    data(){
        return {
            //目前單元
            place:"",
            //語言
            langurage: "1",
            //內容資料
            headerData:[],
        };
    },
    props:["menulist"],
    mounted(){
        //初始化
        this.init();
        //取得頁首子類別資訊
        this.getHeader();
    },
    watch:{},
    methods:{
        //初始化
        init(){
            //取得目前所在類別
            this.place = this.menulist.place;
            if(this.$route.query){
                this.langurage = this.$route.query.lang? this.$route.query.lang: "1";
            }
        },
        //取得所有類別欄位
        async getHeader(){
            try {
                //POST 參數
                let jsonReq = {
                    TYPE:"GET_MENU_OPTION",
                    langurage:this.langurage,
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/Project",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    //設定類別
                    this.headerData = jsonData;
                }
            }catch(err){
                console.log("ErrFunction: getHeader/n "+err);
            }
        },
        //取得切割類別
        GetSublist(PJ_ID){
            //判斷資料列表是否存在，無則回傳空值
            if (!Array.isArray(this.headerData)) return [];
            //TODO 僅取得指定類別的所有次類別資料
             var headerDatas = [];
            if(this.headerData.filter(item => item.PJ_ID == PJ_ID).length >0){
                headerDatas = (this.headerData.filter(item => item.PJ_ID == PJ_ID))[0].SubList;
            }else{
                return [];
            }
            return headerDatas;
        }
    },
}
</script>